var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInTransit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 11C9.4165 11 11.6665 8.75 11.6665 6C11.6665 3.25 9.4165 1 6.6665 1C3.9165 1 1.6665 3.25 1.6665 6C1.6665 8.75 3.9165 11 6.6665 11Z",
    stroke: "#FD7E14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5415 5.99996L5.9565 7.41496L8.7915 4.58496",
    stroke: "#FD7E14",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInTransit);
export default __webpack_public_path__ + "static/media/In Transit.e78ed65910689eb181fd5f53998bb2a0.svg";
export { ForwardRef as ReactComponent };